export const PRODUCTION_WORKER_API_BASE_URL = 'https://poker-knights-3.eranhor.workers.dev';

type WorkerApiEnv = {
  DEV?: boolean;
  PROD?: boolean;
  MODE?: string;
  VITE_WORKER_API_BASE_URL?: string;
  VITE_API_BASE_URL?: string;
  VITE_APP_ENV?: string;
  VITE_RUNTIME_TARGET?: string;
  VITE_USE_FIREBASE_EMULATORS?: string;
};

function cleanBaseUrl(value: string | undefined): string {
  return (value ?? '').trim().replace(/\/+$/, '');
}

function isLoopbackBaseUrl(value: string): boolean {
  if (!value) return false;
  try {
    const hostname = new URL(value).hostname.toLowerCase();
    return hostname === 'localhost'
      || hostname === '::1'
      || hostname === '[::1]'
      || hostname === '0.0.0.0'
      || hostname.startsWith('127.');
  } catch {
    return false;
  }
}

function isLocalEmulatorRuntime(env: WorkerApiEnv): boolean {
  return env.VITE_RUNTIME_TARGET === 'local-emulator'
    || env.VITE_USE_FIREBASE_EMULATORS === 'true';
}

function isProductionRuntime(env: WorkerApiEnv): boolean {
  if (env.VITE_APP_ENV) {
    return env.VITE_APP_ENV === 'production';
  }
  return env.PROD === true || env.MODE === 'production';
}

export function resolveWorkerApiBaseUrl(env: WorkerApiEnv = import.meta.env): string {
  const workerBase = cleanBaseUrl(env.VITE_WORKER_API_BASE_URL);
  if (workerBase) return workerBase;

  if (isLocalEmulatorRuntime(env)) {
    return '';
  }

  const legacyBase = cleanBaseUrl(env.VITE_API_BASE_URL);
  if (legacyBase && !isLoopbackBaseUrl(legacyBase)) {
    return legacyBase;
  }

  if (isProductionRuntime(env)) {
    return PRODUCTION_WORKER_API_BASE_URL;
  }

  return '';
}

export const WORKER_API_BASE_URL = resolveWorkerApiBaseUrl();
